import React, { useId } from 'react';
import { FORM_AI_DOCUMENT_ACCEPT } from '../utils/formAiDocument';

export default function FormAiDocumentAttachment({ file, onChange, loading }) {
  const inputId = useId();
  return (
    <div className="space-y-2 rounded-xl border border-slate-200 p-3">
      <label htmlFor={inputId} className="block text-sm font-medium text-slate-700">Anexar modelo de formulário</label>
      <p id={`${inputId}-help`} className="text-xs text-slate-600">PDF, DOCX, TXT ou XLSX, até 25 MB. A IA lê o documento e propõe seus campos e grupos para revisão. As instruções são opcionais.</p>
      <input id={inputId} type="file" accept={FORM_AI_DOCUMENT_ACCEPT} aria-describedby={`${inputId}-help`}
        className="block w-full text-sm text-slate-700"
        onChange={(event) => { onChange(event.target.files?.[0] || null); event.target.value = ''; }} />
      {file && <div className="flex items-center gap-3 text-sm text-slate-700"><span>{file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)</span><button type="button" onClick={() => onChange(null)} className="text-purple-700 underline">Remover documento</button></div>}
      {loading && <p role="status" className="text-sm text-purple-700">{file ? 'Lendo o documento e identificando campos e grupos…' : 'Preparando a sugestão de formulário…'}</p>}
    </div>
  );
}
